module.exports = __webpack_public_path__ + "static/BicycleFest-2c14f3116297de0c877d2fcc939f192d.jpg";